import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["getBy", "price"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import getCartReviewsQueryKey from "../get-query-key";
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
import getFetchCartOptions from "../../../carts/v2/fetch/get-options";
import getFetchDigitalOfferingsOptions from "../../../fulfillment_offerings/v1/fetch-digital-offerings/get-options";
import getFetchShipOfferingsOptions from "../../../fulfillment_offerings/v1/fetch-ship-offerings/get-options";
var pageActionName = 'tread-cart-reviews-event';
var appId = DOTCOM_UX_ID;
var appName = 'CiCCart';

// ux-tread-cart-reviews/put-cart-reviews
/**
 * @memberof ux-tread-cart-reviews
 * @param {object} parameters - named parameters
 * @prop {string} token - user authentication token
 * @prop {string} visitId - visitId for guest users
 * @prop {string} visitorId - visitorId for guest users
 * @prop {string} country - Capitalized country for request
 * @prop {string} currency - currency of geo
 * @prop {string} locale - locale for request
 * @prop {array} items - Item data for checkout
 * @prop {string} id - UUID identifier for cart reviews job
 * @prop {array} promotionCodes - Array of promotion codes to be applied
 * @prop {string} appId - AppId (uxid from unite)
 * @prop {string} appName - App name included in request headers
 * @prop {string} host - Host for request
 * @returns {object} fetch client parsed JSON response
 */
var createCartReviewsJob = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _window, _window2;
    var items, currency, promotionCodes, signal, id, _getWebShellClientLoc, country, locale, params, body, token, _ref3, visitId, visitorId, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          items = _ref.items, currency = _ref.currency, promotionCodes = _ref.promotionCodes, signal = _ref.signal;
          id = window.crypto.randomUUID();
          _getWebShellClientLoc = getWebShellClientLocale(), country = _getWebShellClientLoc.country, locale = _getWebShellClientLoc.hreflang;
          params = {
            request: {
              country: country.toUpperCase(),
              currency: currency,
              // pull this from carts
              locale: locale,
              items: items,
              promotionCodes: promotionCodes
            }
          };
          body = JSON.stringify(params);
          _context.next = 1;
          return (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.identity) === null || _window === void 0 ? void 0 : _window.getAccessToken();
        case 1:
          token = _context.sent;
          _context.next = 2;
          return (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webShellClient) === null || _window2 === void 0 || (_window2 = _window2.identity) === null || _window2 === void 0 ? void 0 : _window2.getVisitData();
        case 2:
          _t = _context.sent;
          if (_t) {
            _context.next = 3;
            break;
          }
          _t = {};
        case 3:
          _ref3 = _t;
          visitId = _ref3.visitId;
          visitorId = _ref3.visitorId;
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/cart_reviews/v2/").concat(id), {
            method: 'PUT',
            credentials: 'include',
            headers: _objectSpread(_objectSpread({}, formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: DOTCOM_UX_ID,
              appName: appName
            })), {}, {
              'Content-Type': 'application/json; charset=UTF-8'
            }),
            body: body,
            signal: signal
          }, 'Error during PUT/cart_reviews/v2', {
            pageActionName: pageActionName
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createCartReviewsJob(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getCartReviewsJob = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var _window3, _window4;
    var id, signal, token, _ref6, visitId, visitorId, _t2;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref4.id, signal = _ref4.signal;
          _context2.next = 1;
          return (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.webShellClient) === null || _window3 === void 0 || (_window3 = _window3.identity) === null || _window3 === void 0 ? void 0 : _window3.getAccessToken();
        case 1:
          token = _context2.sent;
          _context2.next = 2;
          return (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.webShellClient) === null || _window4 === void 0 || (_window4 = _window4.identity) === null || _window4 === void 0 ? void 0 : _window4.getVisitData();
        case 2:
          _t2 = _context2.sent;
          if (_t2) {
            _context2.next = 3;
            break;
          }
          _t2 = {};
        case 3:
          _ref6 = _t2;
          visitId = _ref6.visitId;
          visitorId = _ref6.visitorId;
          return _context2.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/cart_reviews/v2/").concat(id), {
            method: 'GET',
            credentials: 'include',
            headers: formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: appId,
              appName: appName
            }),
            signal: signal
          }, 'Error during GET/cart_reviews/v2', {
            pageActionName: pageActionName
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getCartReviewsJob(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var getFetchCartReviewsOptions = function getFetchCartReviewsOptions(_ref7) {
  var queryClient = _ref7.queryClient,
    _ref7$isPromosUpdatin = _ref7.isPromosUpdating,
    isPromosUpdating = _ref7$isPromosUpdatin === void 0 ? false : _ref7$isPromosUpdatin;
  return {
    queryKey: getCartReviewsQueryKey({
      isPromosUpdating: isPromosUpdating,
      queryClient: queryClient
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref8) {
        var signal, _yield$queryClient$fe, cartItems, currency, promotionCodes, cartItemsWithSkuIds, offeringResults, offerings, cartItemsWithFulfillmentDetails, job, jobId, response;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              signal = _ref8.signal;
              _context3.next = 1;
              return queryClient.fetchQuery(getFetchCartOptions({
                queryClient: queryClient
              }));
            case 1:
              _yield$queryClient$fe = _context3.sent;
              cartItems = _yield$queryClient$fe.items;
              currency = _yield$queryClient$fe.currency;
              promotionCodes = _yield$queryClient$fe.promotionCodes;
              cartItemsWithSkuIds = cartItems.filter(function (item) {
                return item.skuId;
              }); // Need to account for digital gift cards since they do not have a SHIP type offering
              _context3.next = 2;
              return Promise.allSettled(cartItemsWithSkuIds.map(function (cartItem) {
                return cartItem.shippingMethod === 'DIGITAL_GIFTCARD' ? queryClient.fetchQuery(getFetchDigitalOfferingsOptions({
                  skuId: cartItem.skuId,
                  queryClient: queryClient
                })) : queryClient.fetchQuery(getFetchShipOfferingsOptions({
                  skuId: cartItem.skuId,
                  queryClient: queryClient
                }));
              }));
            case 2:
              offeringResults = _context3.sent;
              offeringResults.forEach(function (result, index) {
                var _window5;
                if (result.status === 'rejected' && (_window5 = window) !== null && _window5 !== void 0 && (_window5 = _window5.newrelic) !== null && _window5 !== void 0 && _window5.addPageAction) {
                  var _result$reason;
                  var cartItem = cartItemsWithSkuIds[index];
                  var isDigital = (cartItem === null || cartItem === void 0 ? void 0 : cartItem.shippingMethod) === 'DIGITAL_GIFTCARD';
                  var eventName = isDigital ? 'cart-reviews-v2-digital-offerings-error' : 'cart-reviews-v2-ship-offerings-error';
                  window.newrelic.addPageAction(eventName, {
                    skuId: cartItem === null || cartItem === void 0 ? void 0 : cartItem.skuId,
                    message: ((_result$reason = result.reason) === null || _result$reason === void 0 ? void 0 : _result$reason.message) || 'Error fetching fulfillment offerings',
                    error: result.reason
                  });
                }
              });
              offerings = offeringResults.filter(function (r) {
                return r.status === 'fulfilled';
              }).map(function (r) {
                return r.value;
              });
              cartItemsWithFulfillmentDetails = cartItems.map(function (cartsCartItem) {
                var _skuOffering$items, _cartsCartItem$valueA, _cartsCartItem$shippi;
                var skuOffering = offerings.find(function (offering) {
                  var _offering$items;
                  return offering === null || offering === void 0 || (_offering$items = offering.items) === null || _offering$items === void 0 ? void 0 : _offering$items.some(function (item) {
                    return item.skuId === cartsCartItem.skuId;
                  });
                });
                var fulfillmentDetails = skuOffering === null || skuOffering === void 0 || (_skuOffering$items = skuOffering.items) === null || _skuOffering$items === void 0 || (_skuOffering$items = _skuOffering$items[0]) === null || _skuOffering$items === void 0 || (_skuOffering$items = _skuOffering$items.fulfillmentOfferings) === null || _skuOffering$items === void 0 ? void 0 : _skuOffering$items[0];

                // For items with VAS (e.g. custom jerseys), strip getBy and price
                // from fulfillmentDetails. Fulfillment offerings are fetched without
                // VAS, so the getByMaxDate reflects the base product. Cart reviews
                // calls fulfillment options internally WITH VAS, causing the pre-VAS
                // date to match a faster, paid shipping tier. Removing the date/price
                // constraint lets cart reviews select the correct tier.
                if (Boolean((_cartsCartItem$valueA = cartsCartItem.valueAddedServices) === null || _cartsCartItem$valueA === void 0 ? void 0 : _cartsCartItem$valueA.length) && fulfillmentDetails) {
                  var _fulfillmentDetails = fulfillmentDetails,
                    getBy = _fulfillmentDetails.getBy,
                    price = _fulfillmentDetails.price,
                    rest = _objectWithoutProperties(_fulfillmentDetails, _excluded);
                  fulfillmentDetails = rest;
                }
                if (cartsCartItem.shippingMethod === 'DIGITAL_GIFTCARD' && fulfillmentDetails && (_cartsCartItem$shippi = cartsCartItem.shippingAddress) !== null && _cartsCartItem$shippi !== void 0 && _cartsCartItem$shippi.email) {
                  var _fulfillmentDetails$l;
                  fulfillmentDetails = _objectSpread(_objectSpread({}, fulfillmentDetails), {}, {
                    location: _objectSpread(_objectSpread({}, fulfillmentDetails.location), {}, {
                      digitalAddress: _objectSpread(_objectSpread({}, (_fulfillmentDetails$l = fulfillmentDetails.location) === null || _fulfillmentDetails$l === void 0 ? void 0 : _fulfillmentDetails$l.digitalAddress), {}, {
                        email: cartsCartItem.shippingAddress.email
                      })
                    })
                  });
                }
                return _objectSpread(_objectSpread({}, cartsCartItem), {}, {
                  fulfillmentDetails: fulfillmentDetails
                });
              });
              _context3.next = 3;
              return createCartReviewsJob({
                items: cartItemsWithFulfillmentDetails,
                currency: currency,
                promotionCodes: promotionCodes,
                signal: signal
              });
            case 3:
              job = _context3.sent;
              jobId = job === null || job === void 0 ? void 0 : job.id;
            case 4:
              if (!(signal !== null && signal !== void 0 && signal.aborted)) {
                _context3.next = 5;
                break;
              }
              throw new DOMException('Aborted', 'AbortError');
            case 5:
              _context3.next = 6;
              return getCartReviewsJob({
                id: jobId,
                signal: signal
              });
            case 6:
              response = _context3.sent;
              if (!(response.status !== 'COMPLETED')) {
                _context3.next = 8;
                break;
              }
              _context3.next = 7;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 25);
              });
            case 7:
              _context3.next = 9;
              break;
            case 8:
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                isPromosUpdating: isPromosUpdating
              }));
            case 9:
              if (response.status !== 'COMPLETED') {
                _context3.next = 4;
                break;
              }
            case 10:
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
                isPromosUpdating: isPromosUpdating
              }));
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function queryFn(_x3) {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    retry: false,
    onError: function onError(error) {
      if (window.newrelic && window.newrelic.addPageAction) {
        window.newrelic.addPageAction('cart-reviews-v2-error', {
          message: error.message,
          error: error
        });
      }
    }
  };
};
export default getFetchCartReviewsOptions;